import NavbarSection from "@/components/LandingPage/Navbar/NavbarSection.vue";
import HeroSection from "@/components/LandingPage/Hero/HeroSection.vue";
import FooterSection from "@/components/LandingPage/Footer/FooterSection.vue";
import ProblemSection from "@/components/LandingPage/ProblemSection/ProblemSection.vue";
import ImpactEcosystemSection from "@/components/LandingPage/ImpactEcosystemSection/ImpactEcosystemSection.vue";
import SustainableSocialImpactNote from "@/components/LandingPage/SustainableSocialImpactNote/SustainableSocialImpactNote.vue";
import ChooseYourLegacySection from "@/components/LandingPage/ChooseYourLegacySection/ChooseYourLegacySection.vue";
import ImpactExchangeRateSection from "@/components/LandingPage/ImpactExchangeRateSection/ImpactExchangeRateSection.vue";
import GovernanceLockSection from "@/components/LandingPage/GovernanceLockSection/GovernanceLockSection.vue";
import TaxAdvantageSection from "@/components/LandingPage/TaxAdvantageSection/TaxAdvantageSection.vue";
import VSIPlatformSection from "@/components/LandingPage/VSIPlatformSection/VSIPlatformSection.vue";
import ChooseLegacyCTA from "@/components/LandingPage/ChooseLegacyCTA/ChooseLegacyCTA.vue";

export default {
  name: "LandingPage",
  components: {
    NavbarSection,
    HeroSection,
    ProblemSection,
    ImpactEcosystemSection,
    SustainableSocialImpactNote,
    ChooseYourLegacySection,
    ImpactExchangeRateSection,
    GovernanceLockSection,
    TaxAdvantageSection,
    VSIPlatformSection,
    ChooseLegacyCTA,
    FooterSection,
  },
};
